import React from "react";

export default function Blog() {
  return (
    <section className="page-title-area sky-blue-bg pt-160 pb-100 ">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="page-title-wrapper text-center">
              <h4 className="styled-text theme-color mb-30">Check out our posts?</h4>
              <h5 className="h1 page-title">Blog</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
